export default __webpack_public_path__ + "static/media/MISTRZ_PRZYMIERZA.73a9cdfb.png";